import React from "react";
import { motion } from "framer-motion";
import { pageVariants } from "../animations/pageTransitions"; // Import animation config
import "./Capabilities.css";
import hospitals from "../../practices_images/hospitals.jpg"; // Ensure this path is correct
import CollapsibleSection from "./CollapsibleSection"; // adjust path if needed

const Hospitals = () => {
  return (
  <motion.div
    variants={pageVariants}
    initial="initial"
    animate="animate"
    exit="exit"
  >
    <div className="cap-container">
    <h1>Hospitals - Coming Soon</h1>

    <div className="cap-section">
        {/* Text Content */}
        <div className="text-content">
            {/* ✅ First 2 sections: normal (always visible) */}
            <h3>Preparing to support care at scale</h3>
            <p>
              Hospitals sit at the center of the healthcare system, coordinating complex care across emergency services, inpatient units, surgical departments, and specialized programs. These environments demand rigorous operational discipline, precise financial management, and resilient technology infrastructure.
            </p>
            <p>
              As care delivery becomes more complex and reimbursement models continue to evolve, hospitals require partners who understand the scale and interconnected nature of their operations.
            </p>

            <h3>The Hospital Environment</h3>
            <p>
              Hospitals operate across multiple service lines, payer models, and regulatory frameworks simultaneously. Clinical excellence depends on tightly coordinated workflows, accurate documentation, and reliable financial and operational insight.
            </p>
            <p>
              Small inefficiencies at this scale can have significant downstream impact on performance, compliance, and sustainability.
            </p>

            {/* ✅ Everything after: collapsible */}
            <CollapsibleSection title="Our Direction">
              <p>
                We are expanding our capabilities to support hospital systems with the same operational clarity and financial discipline we provide to outpatient and specialized care environments.
              </p>
              <p>
                Our planned focus includes strengthening revenue cycle processes, supporting documentation and billing accuracy, improving financial visibility, reinforcing compliance and audit readiness, and supporting technology and security practices that protect patient data and operational continuity.
              </p>
            </CollapsibleSection>

            <CollapsibleSection title="Building the Foundation">
              <p>
                Our approach to hospitals is grounded in preparation, structure, and long term partnership.
              </p>
              <p>
                We are intentionally developing the systems, expertise, and delivery model required to support hospitals responsibly and at scale. This work is underway, and hospital focused services will be introduced as these capabilities are fully established.
              </p>
            </CollapsibleSection>

            <CollapsibleSection title="Looking Ahead">
              <p>
                Hospitals will continue to play a critical role in an increasingly complex healthcare ecosystem.
              </p>
              <p>
                We are building toward this next phase with care, discipline, and purpose.
              </p>
              <p>
                More information on our hospital services will be available soon.
              </p>
            </CollapsibleSection>
        </div>

        {/* Image Section */}
        <div className="image-container">
        {<img src={hospitals} alt="Hospitals" />}
        </div>
    </div>
    </div>

  </motion.div>
  );
};

export default Hospitals;
